import axios from '../axios';

// Get all translations for a locale
export const getTranslations = (locale) => {
  return axios.get(`/translations/${locale}`);
};

// Get translations grouped by category
export const getTranslationsGrouped = (locale) => {
  return axios.get(`/translations/${locale}/grouped`);
};

// Update a single translation
export const updateTranslation = (locale, key, value) => {
  return axios.patch(`/translations/${locale}`, {
    key,
    value,
  });
};

// Bulk update translations
export const bulkUpdateTranslations = (locale, translations) => {
  return axios.patch(`/translations/${locale}/bulk`, {
    translations,
  });
};

// Search translations
export const searchTranslations = (locale, query) => {
  return axios.get(`/translations/${locale}/search`, {
    params: { q: query },
  });
};

// Get translation statistics
export const getTranslationStats = (locale) => {
  return axios.get(`/translations/${locale}/stats`);
};

// Export translations
export const exportTranslations = (locale, format = 'json') => {
  return axios.get(`/translations/${locale}/export`, {
    params: { format },
    responseType: format === 'csv' ? 'blob' : 'json',
  });
};

// Get available locales (from enum, not DB)
export const getLocales = () => {
  return axios.get('/locales');
};

// Update translations for a key in multiple locales
export const updateTranslationsForKey = (key, values) => {
  return axios.post('/translations/update-multi', { key, values });
};

// Bulk update multiple keys across multiple locales (for AI translations)
export const bulkUpdateMultiLocaleTranslations = (translations) => {
  return axios.post('/translations/bulk-update-multi', { translations });
};

// AI Translation API calls

// Check AI translation service status
export const getAITranslationStatus = () => {
  return axios.get('/translations/ai/status');
};

// Translate multiple keys using AI
export const aiTranslateMultiple = (keys, targetLanguages = []) => {
  return axios.post('/translations/ai/translate-multiple', {
    keys,
    target_languages: targetLanguages,
  });
};

// Translate a single key using AI
export const aiTranslateSingle = (key, targetLanguages = []) => {
  return axios.post('/translations/ai/translate-single', {
    key,
    target_languages: targetLanguages,
  });
};
